import { useState } from 'react';

interface Video {
  id: number;
  title: string;
  thumbnail: string;
  videoUrl: string;
  description: string;
}

const VideosGallery = () => {
  const [selectedVideo, setSelectedVideo] = useState<Video | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const videos: Video[] = [
    {
      id: 1,
      title: 'جولة داخل الأسطول الفاخر',
      thumbnail: 'https://public.readdy.ai/ai/img_res/20f4783c36f50b1ce8f7b5403c591586.jpg',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      description: 'تعرف على مجموعتنا المتنوعة من السيارات الفاخرة والمريحة',
    },
    {
      id: 2,
      title: 'خدمات النقل من مطار جدة',
      thumbnail: 'https://readdy.ai/api/search-image?query=Jeddah%20airport%20luxury%20transport%20service%20premium%20car%20pickup%20professional%20driver%20service%20elegant%20vehicle%20at%20modern%20airport%20terminal%20sophisticated%20transportation%20crystal%20clear%20photography&width=800&height=600&seq=airport-video-002&orientation=landscape',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      description: 'خدمة النقل المتميزة من وإلى مطار الملك عبدالعزيز الدولي',
    },
    {
      id: 3,
      title: 'رحلة مميزة إلى الحرم المكي',
      thumbnail: 'https://readdy.ai/api/search-image?query=luxury%20pilgrimage%20transport%20to%20Mecca%20holy%20mosque%20premium%20Islamic%20travel%20service%20elegant%20vehicle%20near%20sacred%20Kaaba%20sophisticated%20religious%20journey%20crystal%20clear%20photography&width=800&height=600&seq=mecca-video-002&orientation=landscape',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      description: 'نقل آمن ومريح للحجاج والمعتمرين إلى بيت الله الحرام',
    },
    {
      id: 4,
      title: 'آراء العملاء الكرام',
      thumbnail: 'https://readdy.ai/api/search-image?query=satisfied%20happy%20customers%20testimonials%20luxury%20transport%20service%20professional%20client%20feedback%20elegant%20business%20meeting%20sophisticated%20customer%20satisfaction%20crystal%20clear%20photography&width=800&height=600&seq=testimonial-video-002&orientation=landscape',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      description: 'شهادات عملائنا الكرام عن جودة خدماتنا المتميزة',
    },
    {
      id: 5,
      title: 'خدمة الضيافة المميزة',
      thumbnail: 'https://readdy.ai/api/search-image?query=luxury%20Arabic%20hospitality%20service%20premium%20coffee%20dates%20traditional%20Saudi%20welcome%20elegant%20service%20presentation%20sophisticated%20customer%20care%20crystal%20clear%20photography&width=800&height=600&seq=hospitality-video-002&orientation=landscape',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      description: 'ضيافة عربية أصيلة مع القهوة والتمر في جميع رحلاتنا',
    },
    {
      id: 6,
      title: 'السلامة والأمان في الرحلات',
      thumbnail: 'https://readdy.ai/api/search-image?query=vehicle%20safety%20security%20measures%20professional%20driver%20training%20luxury%20car%20maintenance%20safety%20equipment%20sophisticated%20transportation%20security%20crystal%20clear%20photography&width=800&height=600&seq=safety-video-002&orientation=landscape',
      videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      description: 'معايير السلامة العالية والأمان التام في جميع رحلاتنا',
    },
  ];

  const handleVideoClick = (video: Video) => {
    setSelectedVideo(video);
  };

  const closeVideoModal = () => {
    setSelectedVideo(null);
  };

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? videos.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === videos.length - 1 ? 0 : prev + 1));
  };

  const getVisibleVideos = () => {
    const visible = [];
    for (let i = -2; i <= 2; i++) {
      const index = (currentIndex + i + videos.length) % videos.length;
      visible.push({ video: videos[index], position: i });
    }
    return visible;
  };

  return (
    <>
      <section id="videos-gallery" className="py-24 bg-gradient-to-b from-luxury-cream to-white overflow-hidden">
        <div className="container mx-auto px-6 lg:px-20">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h3 className="text-luxury-black font-almarai font-bold text-4xl lg:text-5xl mb-4">
              معرض <span className="text-gold">الفيديوهات</span>
            </h3>
            <div className="w-20 h-1 bg-gold mx-auto mb-6"></div>
            <p className="text-luxury-gray font-cairo text-lg max-w-2xl mx-auto">
              شاهد مجموعة من الفيديوهات التي تعرض خدماتنا المتميزة وأسطولنا الفاخر
            </p>
          </div>

          {/* 3D Carousel */}
          <div className="relative h-[500px] flex items-center justify-center">
            {/* Videos Container */}
            <div className="relative w-full h-full flex items-center justify-center">
              {getVisibleVideos().map(({ video, position }) => {
                const isCenter = position === 0;
                const scale = isCenter ? 1 : 0.7;
                const opacity = isCenter ? 1 : 0.5;
                const zIndex = isCenter ? 30 : 20 - Math.abs(position);
                const translateX = position * 320;
                const blur = isCenter ? 0 : 2;

                return (
                  <div
                    key={video.id}
                    onClick={() => isCenter && handleVideoClick(video)}
                    className="absolute transition-all duration-500 ease-out"
                    style={{
                      transform: `translateX(${translateX}px) scale(${scale})`,
                      opacity,
                      zIndex,
                      filter: `blur(${blur}px)`,
                      cursor: isCenter ? 'pointer' : 'default',
                    }}
                  >
                    <div className={`bg-white rounded-3xl overflow-hidden shadow-2xl ${isCenter ? 'ring-4 ring-gold' : ''}`}>
                      {/* Video Thumbnail */}
                      <div className="relative w-80 h-64 bg-gray-100 overflow-hidden">
                        <img
                          src={video.thumbnail}
                          alt={video.title}
                          className="w-full h-full object-cover object-top"
                        />
                        {/* Play Button Overlay */}
                        {isCenter && (
                          <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                            <div className="w-20 h-20 bg-gold rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 shadow-lg">
                              <i className="ri-play-fill text-luxury-black text-4xl ml-1"></i>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Video Info */}
                      {isCenter && (
                        <div className="p-6 text-center">
                          <h4 className="font-almarai font-bold text-xl text-luxury-black mb-3">
                            {video.title}
                          </h4>
                          <p className="font-cairo text-luxury-gray text-sm leading-relaxed">
                            {video.description}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Navigation Buttons */}
            <button
              onClick={handlePrevious}
              className="absolute left-4 lg:left-10 top-1/2 -translate-y-1/2 z-40 w-14 h-14 bg-luxury-black hover:bg-gold text-white hover:text-luxury-black rounded-full flex items-center justify-center transition-all duration-300 shadow-xl cursor-pointer group"
            >
              <i className="ri-arrow-right-s-line text-3xl group-hover:scale-110 transition-transform"></i>
            </button>
            <button
              onClick={handleNext}
              className="absolute right-4 lg:right-10 top-1/2 -translate-y-1/2 z-40 w-14 h-14 bg-luxury-black hover:bg-gold text-white hover:text-luxury-black rounded-full flex items-center justify-center transition-all duration-300 shadow-xl cursor-pointer group"
            >
              <i className="ri-arrow-left-s-line text-3xl group-hover:scale-110 transition-transform"></i>
            </button>
          </div>

          {/* Dots Indicator */}
          <div className="flex items-center justify-center gap-3 mt-12">
            {videos.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`transition-all duration-300 rounded-full cursor-pointer ${
                  index === currentIndex
                    ? 'w-12 h-3 bg-gold'
                    : 'w-3 h-3 bg-luxury-gray/30 hover:bg-luxury-gray/50'
                }`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b">
              <h3 className="font-almarai font-bold text-2xl text-luxury-black">
                {selectedVideo.title}
              </h3>
              <button
                onClick={closeVideoModal}
                className="w-10 h-10 bg-luxury-gray/10 hover:bg-luxury-gray/20 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-close-line text-luxury-gray text-xl"></i>
              </button>
            </div>
            
            {/* Video Player */}
            <div className="relative w-full h-96 lg:h-[500px]">
              <iframe
                src={selectedVideo.videoUrl}
                title={selectedVideo.title}
                className="w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            
            {/* Video Description */}
            <div className="p-6">
              <p className="font-cairo text-luxury-gray text-lg">
                {selectedVideo.description}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideosGallery;
